module.exports = __webpack_public_path__ + "img/strongbox.003eae71.svg";